













































import { Component, Prop, Vue } from 'vue-property-decorator';
import { app } from '@store/modules/app';
import { HeaderStyle } from 'types/header';
import { Link } from 'types/layout';
import NavigationLinkMobile from '@components/header/navigation/mobile/navigation-link-mobile.vue';

@Component({
	components: {
		NavigationLinkMobile
	}
})
export default class MobileNavTemplate extends Vue {
	@Prop()
	private styles!: HeaderStyle;

	appCloudfrontPath = process.env.VUE_APP_CLOUDFRONT_DOMAIN;

	flyoutOpened = false;

	get isAuthenticated(): boolean {
		return app.isAuthenticated;
	}

	get logoLink(): Link {
		return this.isAuthenticated ? { router: 'account-overview' } : { router: 'home' };
	}

	private toggleFlyout(): void {
		this.flyoutOpened = !this.flyoutOpened;

		if (!this.flyoutOpened) {
			this.$emit('remove-hover');
		}
	}
}
